import React from 'react';
import Button from '../../../components/ui/Button';

const NotificationSettings = ({ settings, onUpdate }) => {
  const [preferences, setPreferences] = React.useState(settings);

  const handleSubmit = (e) => {
    e.preventDefault();
    onUpdate(preferences);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <h4 className="font-medium">Email Notifications</h4>
            <p className="text-sm text-gray-600">Receive updates about your sessions</p>
          </div>
          <input
            type="checkbox"
            checked={preferences.emailNotifications}
            onChange={(e) => setPreferences({
              ...preferences,
              emailNotifications: e.target.checked
            })}
            className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
          />
        </div>
        
        <div className="flex items-center justify-between">
          <div>
            <h4 className="font-medium">Session Reminders</h4>
            <p className="text-sm text-gray-600">Get notified before your sessions</p>
          </div>
          <input
            type="checkbox"
            checked={preferences.sessionReminders}
            onChange={(e) => setPreferences({
              ...preferences,
              sessionReminders: e.target.checked
            })}
            className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
          />
        </div>
      </div>
      
      <Button type="submit">Save Preferences</Button>
    </form>
  );
};

export default NotificationSettings;